import type { EntryPoint } from './dictionaries'

let fromTasksList = false

export function markTaskListNavigation(): void {
  fromTasksList = true
}

// Client-side navigation keeps document.referrer stale, so the list marks
// the transition right before router.push.
export function consumeTaskEntryPoint(): EntryPoint {
  const entry: EntryPoint = fromTasksList ? 'tasks_list' : 'direct_url'
  fromTasksList = false
  return entry
}
